import { forAllConsoles } from '../channels';
import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { PRESENCE_OUTPUT } from './topics';

export const HIL_STATUS = 'PRESENCE/HIL_STATUS' as const;

export interface IHilStatusAction {
  type: typeof HIL_STATUS;
  payload: {
    numberOfHilOnline: number;
    timestamp: number;
  };
}

export const hilStatusActionSchema = objectSchemaOf<IHilStatusAction>({
  type: Joi.string().valid(HIL_STATUS).required(),
  payload: objectSchemaOf<IHilStatusAction['payload']>({
    numberOfHilOnline: Joi.number().integer().allow(0).positive().required(),
    timestamp: Joi.number().required(),
  }),
});

/**
 * Broad-casted to all consoles when number of HIL changes
 */
export const hilStatus = actionCreator({
  schema: hilStatusActionSchema,
  topic: PRESENCE_OUTPUT,
  type: HIL_STATUS,
  channels: [forAllConsoles],
});
